import { useTransform } from 'framer-motion'
import Image from 'next/image'
import Link from 'next/link'
import PropTypes from 'prop-types'
import LinesEllipsis from 'react-lines-ellipsis'

import useTime from '../../../../hooks/use-time'
import { S05, Text } from '../../../../styles/typography'
import dateParser from '../../../../utils/date-time'
import dimensions from '../../../../utils/dimensions'
import { UpcomingClassEl } from '../../elements/upcoming-class'

const UpcomingClass = ({
  data: { key, id, cover, name, artist, startTime, endTime, url },
  params: { index, width, x },
}) => {
  const now = useTime(2000)

  const input = [-width * (index + 1), -width * (index + 0.5), -width * index]
  const output = [0, 0, 1]
  const opacity = useTransform(x, input, output)

  return (
    <Link href={url} passHref>
      <a>
        <UpcomingClassEl key={key || id} style={{ opacity }}>
          <div className='content'>
            <div className='cover'>
              {cover && (
                <Image
                  height={dimensions.dw(60)}
                  priority
                  quality={50}
                  src={cover}
                  width={dimensions.dw(60)}
                />
              )}
            </div>
            <LinesEllipsis component={Text} maxLine='2' text={name} />
            <S05 className='artist'>
              By <span>{artist}</span>
            </S05>
            {Boolean(startTime || endTime) && (
              <S05 className='startTime'>
                {now < startTime
                  ? `Starts`
                  : now < endTime
                  ? `Ends`
                  : `Completed on`}{' '}
                {dateParser.time(now < startTime ? startTime : endTime)}
              </S05>
            )}
            {Boolean(startTime) && (
              <S05 className='startTime'>{dateParser.dateFull(startTime)}</S05>
            )}
          </div>
        </UpcomingClassEl>
      </a>
    </Link>
  )
}

export default UpcomingClass

UpcomingClass.propTypes = {
  data: PropTypes.shape({
    artist: PropTypes.string.isRequired,
    cover: PropTypes.string.isRequired,
    endTime: PropTypes.number.isRequired,
    id: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string.isRequired,
    startTime: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  params: PropTypes.shape({
    index: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    x: PropTypes.any.isRequired,
  }).isRequired,
}
